import { Component, Input } from '@angular/core';
import { AdminOrdersService } from '../../../services/orders/admin-orders.service';
import { QoudsUtilService } from '../../../services/utils/qouds-util/qouds-util.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { environment } from 'src/environment';
/**
 *  define and export AdditionalAmountViewComponent class
 */
@Component({
  selector: 'app-additional-view',
  templateUrl: './additional-amount-view.component.html',
  styleUrls: ['./additional-amount-view.component.scss'],
})
export class AdditionalAmountViewComponent {
  @Input() orderData: any;
  flag: boolean = false;
  received = {
    is_received: true,
  };
  saveDialogRef: MatDialogRef<AlertBoxComponent>;
  successImg: boolean = true;
  confirmMsg = 'تم الإضافة بنجاح';

  constructor(
    private order: AdminOrdersService,
    private dialog: MatDialog,
    private qoudsUtil: QoudsUtilService) {}

  deliveredOrder(id, received) {
    this.flag = true;
    this.order.changePaymentStatus(id, received).subscribe(
      () => {
        this.orderData.sub_order.forEach((order) => {
          if (order.pk == id) {
            order.payment_status = 'مستلم';
          }
        });
      },
      (error) => {
        try {
          console.log(error);
        } catch {
          console.log(error);
        }
      }
    );
  }

  updateQouds(orderId) {
    this.qoudsUtil.updateQouds(this, orderId);
  }

  copyOrderLink(id) {
    if (environment.production) {
      this.copyLink(
        `https://ayen.com.sa/add-request/payment/${id}?payNow=true`
      );
    } else {
      this.copyLink(
        `https://staging.ayen.com.sa/add-request/payment/${id}?payNow=true`
      );
    }
  }

  copyLink(link: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.showAlertBox();
  }

  showAlertBox() {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: true,
        message: 'تم النسخ بنجاح',
        button: 'تم',
      },
    });
  }
}
